import { Component, OnInit } from '@angular/core';
import { ImportField, PhoneNumberValidator, StringMatchValidator, DataBuilder, DataImporter, IProgressIndicator } from '../csv-importer/csv-importer.component';
import { ParseResult } from 'ngx-papaparse';
import { IdGenerator } from 'src/app/text/id-generator';
import { Strings } from 'src/app/text/strings';
import { Contact, ContactResource, VERSION } from '@apaq/orgkit-js';
import { container } from 'tsyringe';
import log from 'loglevel';

class ContactDataBuilder implements DataBuilder<any> {
  buildData(fields: ImportField<any>[], data: ParseResult): Contact[] {
    log.debug('Building data');
    let contacts: Contact[] = [];
    
    let lastContact: Partial<Contact>;
    data.data.forEach((entry:any) => {
      let contact: Partial<Contact> = {
        countryCode: 'DK',
        customer: true
      };
      
      fields.forEach(field => {
        if (field.matchField != null) {
          let value = entry[field.matchField];
          if (value != null && typeof value == 'string') {
            value = value.trim();
          }

          if (field.validator != null && !field.validator.isValid(value)) {
            return;
          }

          switch (field.name) {
            case 'number':
              contact.number = value;
              break;
            case 'name':
              contact.name = value;
              break;
            case 'street':
              contact.street = value;
              break;
            case 'apartment':
              contact.apartment = value;
              break;
            case 'postalcode':
              contact.postalCode = Strings.isNotBlank(value) ? value : '';
              break;
            case 'city':
              contact.city = Strings.isNotBlank(value) ? value : '';
              break;
            case 'phone':
              if (Strings.isNotBlank(value)) {
                if (field.formatter) {
                  contact.phone = field.formatter.format(value);
                } else {
                  contact.phone = value;
                }
              } else {
                contact.phone = undefined;
              }
              break;
            case 'email':
              contact.email = Strings.isNotBlank(value) ? value : null;
              break;
            case 'taxid':
              contact.registrationNo = Strings.isNotBlank(value) ? value : null;
              break;
          }
        }
      });

      if (Strings.isNotBlank(contact.name!) &&
        Strings.isNotBlank(contact.street!) &&
        (Strings.isNotBlank(contact.postalCode!) || Strings.isNotBlank(contact.city!))) {

        contact.id = IdGenerator.generate('cont');
        contacts.push(contact as Contact);
      }
    });
    return contacts;
  }
}


class ContactDataImporter implements DataImporter<any> {
  constructor(private contactResource: ContactResource) { }

  importData(data: Contact[], progress: IProgressIndicator) {
    let index = 0;
    const maxPageSize = 50;
    const numberOfContacts = data.length;
    const promises: Promise<Contact[]>[] = [];
    let page: Contact[] = [];

    for(let i = 0;i<data.length;i++) {
      page.push(data[i]);

      if((i+1) % maxPageSize === 0 || (i+1) === data.length) {
        promises.push(this.contactResource.saveAll(page));
        page = [];
      }
    }

    progress.progress(0.0, 'Preparing');

    Promise.all(promises).then(result => {
      progress.complete('')
    }).catch(error => {
      log.debug(`Error occured while uploading data: ${error}`);
      progress.error(error);
    });
  }
}

@Component({
  selector: 'ws-contact-importer',
  templateUrl: './contact-importer.component.html',
  styleUrls: ['./contact-importer.component.scss']
})
export class ContactImporterComponent {

  phoneAdaptor = new PhoneNumberValidator('DK');
  fields: ImportField<any>[] = [
    new ImportField('number', ['nummer', 'id'], $localize `Customer no.`, $localize `A custom number for the customer.`),
    new ImportField('name', ['navn'], $localize `Name`, $localize `The name of the customer`, true, new StringMatchValidator(/^(?!\d+$).+$/)),
    new ImportField('street', ['adresse', 'gade', 'address'], $localize `Street`, $localize `The street and house number`, true, new StringMatchValidator(/^(?!\d+$).+$/)),
    new ImportField('apartment', ['lejlighed', 'side', 'floor'], $localize `Apartment`, $localize `The floor and side for the address`, false, new StringMatchValidator(/^(?!\d+$).{0,15}$/)),
    new ImportField('postalcode', ['postnr', 'postnummer', 'zip', 'zipcode', 'postal'], $localize `Postal Code`, $localize `The postalcode for the address`, true, new StringMatchValidator(/^([0-9]{4,5})$/)),
    new ImportField('city', ['by', 'town'], $localize `City`, $localize `The city for the address`, true, new StringMatchValidator(/^(?!\d+$).+$/)),
    new ImportField('phone', ['telefon', 'telephone', 'mobile'], $localize `Phone Number`, $localize `The phone number for the customer`, false, this.phoneAdaptor, this.phoneAdaptor),
    new ImportField('email', ['emailaddress', 'emailadresse', 'e-mail'], $localize `Email`, $localize `The email address of the customer`, false, new StringMatchValidator(/^[\w\.-]+\@[\w\.-]+$/)),
    new ImportField('taxid', ['cvr', 'vies', ''], $localize`Tax ID`, $localize `The contact's tax id`, false, new StringMatchValidator(/^(?!\d+$).{4,20}$/)),
  ];

  dataBuilder: DataBuilder<Contact[]> = new ContactDataBuilder();

  dataImporter?: DataImporter<Contact[]>;


  constructor(resource: ContactResource) {
    this.dataImporter = new ContactDataImporter(resource);
  }

  onStep(step: string) {
    if (step === 'done') {
    }
  }




}
